<template>
  <div class="flex-row gap-xs flex-wrap">
    <dd-pill v-for="label of cellProps" :key="label.id" :color="label.color">
      {{ label.name }}
    </dd-pill>
  </div>
</template>

<script>
export default {
  name: "Labels.vue",
  props: {
    cellProps: Array,
  },
};
</script>

<style scoped>

</style>
